import React from 'react';

// reactstrap components
import {
  Button,
  Card,
  Container,
  Row,
  Col,
  Badge,
  CardBody,
  Form,
  InputGroup,
  Input,
  Spinner
} from "reactstrap";

import {
  RiUserVoiceLine,
} from "react-icons/ri";

import withNavigateHook from "../../hooks/withNavigationHook";
import { SeoHelper } from "../../components/helpers/SeoHelper";
import Api from "../../components/helpers/Api";
import { updatePlaylist } from "../../components/helpers/CuratedPlaylistHelpers";
import KstTrackLinks from "../../components/kst/KstTrackLinks";

class SearchBySong extends React.Component {
  constructor() {
    super();
    // Extended state to include new input fields
    this.state = {
      query: "",
      results: [],
      loading: false,
      hasSearched: false,
      value: '',
      items: [],
      draggingItem: null,
      newItemName: '',
      newItemImage: '',
      email: '',
      saveNotes: '',
      yourName: '',         // NEW: Sender's name
      recipientName: '',    // NEW: Recipient's name
      saveName: '',
      emailError: '',
      saveNameError: '',
      formModalShare: false,
      formModalSent: false,
      formModalSave: false,
      isLocked: false,
      songAddedMessage: null
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  groupResultsBySong = (results) => {
    const grouped = {};

    results.forEach((item) => {
      if (!grouped[item.id]) {
        grouped[item.id] = {
          id: item.id,
          title: item.title,
          alternativeTitle: item.alternativeTitle,
          authors: item.authors || [],
          kstTracks: item.kstTracks || [],
          wordsSongBooks: []
        };
      }

      grouped[item.id].wordsSongBooks.push({
        songBook: {
          id: item.songBookId,
          title: item.songBookTitle
        },
        songBookSongNumber: item.songBookSongNumber,
        keySignature:  item.keySignature  || null,
        timeSignature: item.timeSignature || null,
        tempoBpm:      item.tempoBpm      ?? null,
        meter:         item.meter         || null,
        ccliNumber:    item.ccliNumber    || null
      });
    });

    return Object.values(grouped);
  };

  getQueryFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("q") || "";
  };

  // New change handlers for the additional input fields
  onChangeYourName = (e) => {
    this.setState({ yourName: e.target.value });
  };

  onChangeRecipientName = (e) => {
    this.setState({ recipientName: e.target.value });
  };

  // Existing change handler for email
  onChangeEmail = (e) => {
    this.setState({
      email: e.target.value,
      emailError: "",
    });
  };

  handleDragStart = (e, item) => {
    this.setState({ draggingItem: item });
    e.dataTransfer.setData('text/plain', '');
  };

  handleDragEnd = () => {
    this.setState({ draggingItem: null });
  };

  handleDragOver = (e) => {
    e.preventDefault();
  };

  handleDrop = (e, targetItem) => {
    const { draggingItem, items } = this.state;
    if (!draggingItem) return;

    const currentIndex = items.indexOf(draggingItem);
    const targetIndex = items.indexOf(targetItem);

    if (currentIndex !== -1 && targetIndex !== -1) {
      items.splice(currentIndex, 1);
      items.splice(targetIndex, 0, draggingItem);
      this.setState({ items });
    }

    // Reassign `i` for ordering on curated song list
    let recalibratedItems = [];
    for (let i = 0; i < items.length; i++) {
      const current = items[i];
      current.i = i;
      recalibratedItems.push(current);
    }
    sessionStorage.setItem("curated-songs", JSON.stringify(recalibratedItems));
  };

  handleNameChange = (e) => {
    this.setState({ newItemName: e.target.value });
  };

  handleImageChange = (e) => {
    this.setState({ newItemImage: e.target.value });
  };

  addNewItem = () => {
    // Generate a unique ID for the new item
    const newItemId = Math.max(...this.state.items.map((item) => item.id)) + 1;
    const newItem = {
      id: newItemId,
      name: this.state.newItemName,
      image: this.state.newItemImage,
    };

    // Add the new item to the state
    this.setState({
      items: [...this.state.items, newItem],
      newItemName: '', // Clear the input fields
      newItemImage: '',
    });
  };

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  performSearch = async () => {
    const { query } = this.state;
    if (query.trim().length < 2) return;

    this.setState({ loading: true, hasSearched: true });

    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth"
    });

    try {
      const { data } = await Api.get(
          `/words/search?q=${encodeURIComponent(query)}`
      );

      this.setState({ results: data || [] });

      if (typeof window.gtag === 'function') {
        window.gtag("event", "view_search_results", {
          search_term: query
        });
      }
    } catch (e) {
      console.error("Search failed", e);
      this.setState({ results: [] });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleSubmitSong = (chosenSong) => {
    if (typeof window.gtag === 'function') {
      window.gtag("event", "select_content", {
        content_type: "song_suggestion"
      });
    }

    // ✅ update query in CLASS state
    // this.setState({ query: chosenSong.title });

    const newKey = `${chosenSong.id}/${chosenSong.songBookId}`;

    const currentCuratedSongs =
        sessionStorage.getItem("curated-songs") &&
        sessionStorage.getItem("curated-songs") !== "null" &&
        JSON.parse(sessionStorage.getItem("curated-songs")).length > 0
            ? JSON.parse(sessionStorage.getItem("curated-songs"))
            : [];

    const isAlreadyAdded = currentCuratedSongs.some((s) => s.key === newKey);

    let updatedCuratedSongs;

    if (!isAlreadyAdded) {
      if (typeof window.gtag === 'function') {
        window.gtag("event", "select_song", {
          source: "search"
        });
      }

      const newPlayOrder =
          currentCuratedSongs.length > 0
              ? currentCuratedSongs[currentCuratedSongs.length - 1].playOrder + 1
              : 0;

      const authorNames = (chosenSong.authors || [])
          .map((a) => a.name)
          .join(", ");

      const newSong = {
        key: newKey,
        songId: chosenSong.id,
        songTitle: chosenSong.title,
        alternativeTitle: chosenSong.alternativeTitle,
        songBookId: chosenSong.songBookId,
        songBookTitle: chosenSong.songBookTitle,
        songBookSongNumber: chosenSong.songBookSongNumber,
        keySignature:  chosenSong.keySignature  || null,
        timeSignature: chosenSong.timeSignature || null,
        tempoBpm:      chosenSong.tempoBpm      ?? null,
        meter:         chosenSong.meter         || null,
        ccliNumber:    chosenSong.ccliNumber    || null,
        i: newPlayOrder,
        playOrder: newPlayOrder,
        authors: chosenSong.authors || [],
        authorNames,
        kstTracks: chosenSong.kstTracks || []
      };

      updatedCuratedSongs = [...currentCuratedSongs, newSong];
    } else {
      updatedCuratedSongs = currentCuratedSongs.filter((s) => s.key !== newKey);
    }

    sessionStorage.setItem("curated-songs", JSON.stringify(updatedCuratedSongs));

    // Playlist sync (if applicable)
    if (sessionStorage.getItem("playlist")) {
      const playlist = JSON.parse(sessionStorage.getItem("playlist"));
      updatePlaylist(
          playlist.id,
          playlist.name,
          playlist.saveNotes,
          updatedCuratedSongs
      ).catch(() => console.error("Playlist save failed"));
    }

    this.setState(
        { songAddedMessage: isAlreadyAdded
              ? `"${chosenSong.title}" removed from your song-flow`
              : `"${chosenSong.title}" added to your song-flow` },
        () => {
          setTimeout(() => {
            this.setState({ songAddedMessage: null });
          }, 2500);
        }
    );

    // ✅ stay on page — no redirect
  };

  componentDidMount() {
    const queryFromUrl = this.getQueryFromUrl();

    if (queryFromUrl) {
      this.setState(
          { query: queryFromUrl },
          () => this.performSearch()
      );
    }

    this.setState({
      items: !this.state.items || this.state.items.length === 0
          ? sessionStorage.getItem("curated-songs") == null ? [] : JSON.parse(sessionStorage.getItem("curated-songs"))
          : this.state.items
    });

    this.state.items.sort((a, b) => a.i > b.i);

    const passages = sessionStorage.getItem("selected-passages") == null ? [] : JSON.parse(sessionStorage.getItem("selected-passages"));
    const themes = sessionStorage.getItem("selected-themes") == null ? [] : JSON.parse(sessionStorage.getItem("selected-themes"));

    this.setState({
      choosenPassageButtons: passages
          .sort((a, b) => a.displayOrder > b.displayOrder ? 1 : -1)
          .map((passage, index) => {
            return (
                <div className="col-4" key={index}>
                  <Badge className='text-uppercase mx-2' color='primary' pill>
                    {passage.book} {passage.chapter}
                    {passage.verseFrom ? "v" + passage.verseFrom : null}
                    {passage.verseTo ? "-" + passage.verseTo : null}
                  </Badge>
                </div>
            );
          })
    });

    this.setState({
      chosenThemeButtons: themes.map((theme, index) => {
        return (
            <div className="col-4" key={index}>
              <Badge className='text-uppercase mx-2' color='primary' pill>
                {theme.title}
              </Badge>
            </div>
        );
      })
    });

    const swoCount = parseInt(localStorage.getItem("swo") || "0", 10);
    const isNotLoggedIn = !sessionStorage.getItem("customer");
    if (swoCount >= 3 && isNotLoggedIn) {
      this.setState({ isLocked: true, formModalUpgrade: true });
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'build_service', {
        source: 'search'
      });
    }
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    alert('A name was submitted: ' + this.state.value);
    event.preventDefault();
  }

  render() {
    return (
        <div className="search-by-song-page">
          <SeoHelper
              uri="/songs/search"
              title = "Search by Song Title"
              noindex={true}
          />

          <div className="position-relative">
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>search by song</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon className="fill-white" points="2560 0 2560 100 0 100"/>
                </svg>
              </div>
            </section>
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <div className={this.state.isLocked ? "locked-overlay" : ""}>
              <Container>
                <Row className="justify-content-center">
                  <Col lg="12">
                    <Row className="justify-content-center">
                      <Col lg="12">
                        <Card className="card-lift--hover shadow border-0">
                          <CardBody className="py-5">
                            <h2 className="text-primary text-uppercase d-flex align-items-center"
                                style={{fontSize: '1rem'}}>
                            <span className="icon icon-shape icon-shape-primary rounded-circle">
                              <RiUserVoiceLine/>
                            </span>
                              <span className="ml-3">Add a song by name</span>
                            </h2>
                            <p className="description mt-3">
                              <Form
                                  onSubmit={(e) => {
                                    e.preventDefault();
                                    if (!this.state.loading) {
                                      this.performSearch();
                                    }
                                  }}
                              >
                                <InputGroup>
                                  <Input
                                      value={this.state.query}
                                      placeholder="Enter song title"
                                      onChange={(e) =>
                                          this.setState({query: e.target.value})
                                      }
                                  />
                                  <Button
                                      color="primary"
                                      type="submit"
                                      disabled={this.state.loading}
                                  >
                                    {this.state.loading ? "Searching…" : "SEARCH"}
                                  </Button>
                                </InputGroup>
                              </Form>
                            </p>
                            {this.state.loading &&(
                                <div
                                    className="mt-5 d-flex flex-column align-items-center"
                                    style={{ minHeight: "160px" }}
                                >
                                  {/* spinner ONLY */}
                                  <div style={{ animation: "none" }}>
                                    <Spinner
                                        color="primary"
                                        style={{
                                          width: "2rem",
                                          height: "2rem"
                                        }}
                                    />
                                  </div>

                                  {/* static text – explicitly cancel animation */}
                                  <div
                                      className="mt-3"
                                      style={{
                                        fontSize: "0.95rem",
                                        animation: "none",
                                        transform: "none"
                                      }}
                                  >
                                    Searching for songs…
                                  </div>
                                </div>
                            )}

                            {!this.state.loading &&
                                this.state.hasSearched &&
                                this.state.results.length === 0 && (
                                    <div className="text-muted mt-4">
                                      No results found
                                    </div>
                                )}

                            {this.groupResultsBySong(this.state.results).map((song) => {

                              const authorLine = (song.authors || [])
                                  .map(a => a.name)
                                  .join(", ");

                              return (
                                  <Card key={song.id} className="mt-3 border-0 shadow-sm">
                                    <CardBody>

                                      <div className="row align-items-start search-by-song-result-row">

                                        {/* LEFT: Song title + authors */}
                                        <div className="col-12 col-md-6 search-by-song-title-column" style={{ fontWeight: "bold" }}>
                                          {song.title}
                                          {song.alternativeTitle && (
                                              <>
                                                <br />({song.alternativeTitle})
                                              </>
                                          )}
                                          <KstTrackLinks kstTracks={song.kstTracks} />

                                          {authorLine && (
                                              <div
                                                  style={{
                                                    fontWeight: "normal",
                                                    fontSize: "0.85rem",
                                                    color: "#555",
                                                    marginTop: "0.25rem"
                                                  }}
                                              >
                                                {authorLine}
                                              </div>
                                          )}
                                        </div>

                                        {/* RIGHT: Songbook toggles */}
                                        <div className="col-12 col-md-6 search-by-song-songbook-column">

                                          {song.wordsSongBooks.map((wsb, idx) => {

                                            const key = `${song.id}/${wsb.songBook.id}`;

                                            const isAlreadyAdded =
                                                sessionStorage.getItem("curated-songs") &&
                                                JSON.parse(sessionStorage.getItem("curated-songs") || "[]")
                                                    .some(item => item.key === key);

                                            return (
                                                <div
                                                    key={key}
                                                    className="search-by-song-songbook-option mb-2"
                                                >
                                                  <label
                                                      className="custom-toggle search-by-song-toggle"
                                                      style={{ marginBottom: (() => {
                                                        const p = [];
                                                        if (wsb.keySignature)  p.push(1);
                                                        if (wsb.timeSignature) p.push(1);
                                                        if (wsb.tempoBpm)      p.push(1);
                                                        if (wsb.meter)         p.push(1);
                                                        if (wsb.ccliNumber)    p.push(1);
                                                        return p.length > 0 ? "0" : "-10px";
                                                      })() }}
                                                  >

                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`${song.id}/${wsb.songBook.id}/${idx}`}
                                                        name={`${song.id}/${wsb.songBook.id}`}
                                                        checked={isAlreadyAdded}
                                                        onChange={() =>
                                                            this.handleSubmitSong({
                                                              ...song,
                                                              songBookId: wsb.songBook.id,
                                                              songBookTitle: wsb.songBook.title,
                                                              songBookSongNumber: wsb.songBookSongNumber,
                                                              keySignature:  wsb.keySignature  || null,
                                                              timeSignature: wsb.timeSignature || null,
                                                              tempoBpm:      wsb.tempoBpm      ?? null,
                                                              meter:         wsb.meter         || null,
                                                              ccliNumber:    wsb.ccliNumber    || null
                                                            })
                                                        }
                                                    />

                                                    <span className="custom-toggle-slider rounded-circle" />

                                                    <span className="search-by-song-songbook-label">
                                                      {wsb.songBook.title}&nbsp;
                                                      ({wsb.songBookSongNumber})
                                                    </span>

                                                  </label>
                                                  {(() => {
                                                    const parts = [];
                                                    if (wsb.keySignature)  parts.push(`Key: ${wsb.keySignature}`);
                                                    if (wsb.timeSignature) parts.push(`Time Signature: ${wsb.timeSignature}`);
                                                    if (wsb.tempoBpm)      parts.push(`Tempo: ${wsb.tempoBpm} bpm`);
                                                    if (wsb.meter)         parts.push(`Metre: ${wsb.meter}`);
                                                    if (wsb.ccliNumber)    parts.push(`CCLI: ${wsb.ccliNumber}`);
                                                    return parts.length > 0
                                                        ? <div className="search-by-song-songbook-meta">{parts.join(' · ')}</div>
                                                        : null;
                                                  })()}
                                                </div>
                                            );
                                          })}

                                        </div>

                                      </div>

                                    </CardBody>
                                  </Card>
                              );
                            })}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </div>
          </section>
          {this.state.songAddedMessage && (
              <div
                  style={{
                    position: "fixed",
                    bottom: "90px",           // sits above your bottom bar
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#2dce89", // Argon success green
                    color: "white",
                    padding: "12px 20px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    zIndex: 1100,
                    fontSize: "0.9rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}
              >
                <span style={{ fontSize: "1rem" }}>✓</span>
                {this.state.songAddedMessage}
              </div>
          )}
          <div style={{
            position: "fixed",
            bottom: "0",
            left: "0",
            width: "100%",
            backgroundColor: "white",
            padding: "40px",
            boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.2)",
            zIndex: "1000"
          }}>
            <div className="col-md-12 col-xs-12"
                 style={{position: "fixed", bottom: "20px", right: "0px", zIndex: "1000"}}>
              <Button
                  type="submit"
                  id="continueButton"
                  className="btn-icon mb-3 mb-sm-0 mt-5 col-md-12 col-xs-12"
                  color="primary"
                  onClick={() => this.props.navigation("/scripture/curated-songs")}
                  disabled={!(sessionStorage.getItem("curated-songs") && sessionStorage.getItem("curated-songs") != 'null' && JSON.parse(sessionStorage.getItem("curated-songs")).length > 0 && !sessionStorage.getItem("playlist"))}
              >
                <span className="btn-inner--text">Go to song-flow</span>
              </Button>
            </div>
          </div>
        </div>
    );
  }
}

export default withNavigateHook(SearchBySong);
